import { useEffect, useState } from "react"

/**
 * Subscribes to a CSS media query. Defaults to `false` when `matchMedia` is
 * unavailable (SSR / older test environments) so desktop layouts render first.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false
    }
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return

    const media = window.matchMedia(query)
    const onChange = () => setMatches(media.matches)
    onChange()

    media.addEventListener("change", onChange)
    return () => media.removeEventListener("change", onChange)
  }, [query])

  return matches
}
